import type { ParseResult } from './types'
import { parseCustomElementsModule } from './customElementsJs/parseCustomElementsModule'

export const parseElementDefinitions = (jsContent: string): ParseResult => {
    const entries = parseCustomElementsModule(jsContent)

    return {
        elements: entries,
    }
}
